<div class="cards-container">
    <ng-container *ngFor="let invoice of invoices">
        <div class="invoice-card ccc ccc-hover flex-grow-1 cursor-pointer animated-col" 
            [ngClass]="{'invoice-not-paid': !invoice?.isPaid, 'invoice-overdue': invoice?.isOverdue}" 
            (click)="navigateToDetailHandler(invoice.invoiceId)">
            <div class="invoice-number mb-1 fw-bold">
                <dynamic-field [props]="props?.Number" [canBeEmpty]="true">
                    <div class="d-flex align-items-center justify-content-center">
                        <span HJSuppress class="text-ellipsis"
                            textEllipsisToTooltip ngbTooltip=""
                            [ngClass]="{'overdue-color': invoice?.isOverdue}">
                            {{invoice?.number}}
                        </span>
                        <button class="btn copy-clipboard-btn custom-copy-clipboard-btn ms-2" [cdkCopyToClipboard]="invoice?.number" 
                            (click)="showClipboardNotification($event)">
                            <i class="app-icon icon icon-copy icon-md2"></i>
                        </button>
                    </div>
                </dynamic-field>
            </div>

            <div class="invoice-contracts mb-1" *ngIf="invoice?.contracts?.length > 0">
                <dynamic-field [props]="props?.Contracts" [canBeEmpty]="true">
                    <div class="d-flex flex-wrap align-items-center justify-content-center gap-1">
                        <div class="fw-semibold">{{'invoice.contract' | translate}}:</div>
                        <div class="fw-semibold text-primary" HJSuppress>
                            {{invoice?.contracts[0]}}
                        </div>
                        <button *ngIf="invoice?.contracts?.length > 1" 
                            type="button" class="btn view-more-btn"
                            (click)="openDetailsListModalInvoiceContracts($event, invoice?.contracts)"
                        >
                            {{'common.viewMore' | translate}}
                        </button>
                    </div>         
                </dynamic-field>
            </div>

            <div class="invoice-details">
                <dynamic-field [props]="props?.IssuedDate" [canBeEmpty]="true">
                    {{'invoice.issuedDate' | translate}}
                    <span HJSuppress class="fw-bold">
                        {{invoice?.issuedDate | localizedDate}}
                    </span>
                </dynamic-field>
            </div>

            <div class="invoice-value">
                <dynamic-field [props]="props?.Value" [canBeEmpty]="true" >
                    <div class="value-label fw-semibold">{{'invoice.value' | translate}}</div>
                    <div HJSuppress class="fw-bold fs-4">
                        {{invoice?.totalWithVAT | number : '1.'}} {{invoice?.currencyCode}}
                    </div>
                </dynamic-field>
            </div>

            <div class="outstanding-amount">
                <dynamic-field [props]="props?.OutstandingAmount" [canBeEmpty]="true">
                    <span class="value-label fw-semibold">{{'invoice.outstandingAmount' | translate}}</span>
                    <span HJSuppress class="l-outstanding-amount-txt fw-bold" [ngClass]="{'overdue-color': invoice?.isOverdue}">
                        {{invoice?.outstandingAmount | number : '1.' | replaceIfNull}}
                        <ng-container *ngIf="invoice?.outstandingAmount !== null">
                            {{invoice?.currencyCode}}
                        </ng-container>
                    </span>
                </dynamic-field>
            </div>

            <div class="invoice-details">
                <dynamic-field [props]="props?.Type" [canBeEmpty]="true">
                    {{'invoice.type' | translate}}
                    <span HJSuppress class="fw-bold">
                        {{invoice?.type}}
                    </span>
                </dynamic-field>
            </div>

            <div class="invoice-categories">
                <dynamic-field [props]="props?.Categories" [canBeEmpty]="true">
                    <div *ngIf="invoice?.categories?.length > 0" class="d-flex flex-column align-items-center">
                        <div class="d-flex align-items-center gap-1">
                            <div class="value-label fw-semibold">{{'invoice.category' | translate}}:</div>
                            <ng-container *ngFor="let category of invoice?.categories | slice: 0 : 1; let last = last">
                                <span HJSuppress>
                                    {{category}}
                                </span>
                                <span *ngIf="!last || invoice?.categories?.length > 1">, </span>
                            </ng-container>
                        </div>

                        <button *ngIf="invoice?.categories.length > 1" 
                            type="button" class="btn view-more-btn"
                            (click)="openDetailsListModalInvoiceCategories($event, invoice?.categories)"
                        >
                            {{'common.viewMore' | translate}}
                        </button>
                    </div>
                </dynamic-field>
            </div>

            <div class="due-date fw-semibold">
                <dynamic-field [props]="props?.DueDate" [canBeEmpty]="true" >
                    <div class="value-label">{{'invoice.dueDate' | translate}}</div>
                    <div HJSuppress class="fw-bold">
                        {{invoice?.dueDate | localizedDate}}
                    </div>
                </dynamic-field>
            </div>

            <div HJSuppress class="state">
                <dynamic-field [props]="props?.IsPaid" [canBeEmpty]="true">
                    <div *ngIf="invoice?.isPaid" class="d-flex align-items-center justify-content-center">
                        <i class="app-icon icon icon-check-circle-fill icon-xl paid-icon me-2"></i>
                        {{'invoice.status.paid' | translate}}
                    </div>
                    <div *ngIf="!invoice?.isPaid && !invoice?.isOverdue" class="d-flex align-items-center justify-content-center">
                        <i class="app-icon icon icon-close-circle-fill icon-xl not-paid-icon me-2"></i>
                        {{'invoice.status.notPaid' | translate}}
                    </div>
                    <div *ngIf="invoice?.isOverdue" class="overdue-color d-flex align-items-center justify-content-center">
                        <i class="app-icon icon icon-warning-triangle-fill icon-xl overdue-icon me-2"></i>
                        {{'invoice.status.overdue' | translate}}
                    </div>
                </dynamic-field>
            </div>
        </div>
    </ng-container>
</div>
